import { render } from "./IndexPage.vue?vue&type=template&id=89bd4374"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"
script.render = render

export default script